import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { partnerPortalApi } from '../../api/partnerPortal';

export function PartnerForgotPasswordPage() {
  const [message, setMessage] = useState<string | null>(null);
  const { register, handleSubmit, formState: { isSubmitting } } = useForm<{ email: string }>();

  const onSubmit = async (values: { email: string }) => {
    const result = await partnerPortalApi.forgotPassword(values.email);
    setMessage(result.data.message);
  };

  return (
    <div className="login-page">
      <div className="card" style={{ maxWidth: 420, margin: '80px auto', borderTop: '4px solid var(--vri-green)' }}>
        <h1>Reset Your Password</h1>
        {message ? (
          <p>{message}</p>
        ) : (
          <form onSubmit={handleSubmit(onSubmit)}>
            <p className="muted">Enter your email and we'll send you a link to reset your password.</p>
            <label>Email Address<input type="email" autoFocus {...register('email', { required: true })} /></label>
            <div className="form-actions"><button type="submit" disabled={isSubmitting}>{isSubmitting ? 'Sending…' : 'Send Reset Link'}</button></div>
          </form>
        )}
        <p className="muted" style={{ fontSize: 13, marginTop: '1.5em' }}><Link to="/login">Return to sign in</Link></p>
      </div>
    </div>
  );
}
